module.exports = __webpack_public_path__ + "img/Weedoit.c1f4ff73.webp";